import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange,
        selectedCardsGroupsChange,
        popUpMessageChange,
        deletedCardsGroupsChange } from '../../actions/index'
import { _ } from '../../functions/translator'
import { handlePosition, handleVisibility } from '../../functions/popUpMenu/visibiltyFunctions';
import AssignButton from './assignButton';


class AsignUsersButton extends React.Component{
          
    componentDidMount() {
        setTimeout(() => {
            this.button.classList.add(`button-transition-${this.props.index}`)
            handleVisibility(this.button, this.props.popUpMenu.expanded)
            handlePosition(this.button, this.props.position, this.props.popUpMenu.close)
        }, 1);
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedCardsGroups !== prevProps.selectedCardsGroups) {
            handlePosition(this.button, this.props.position, this.props.popUpMenu.close)
        }
    }

    render(){   
        if (this.button) {
            handleVisibility(this.button, this.props.popUpMenu.expanded)
            handlePosition(this.button, this.props.position, this.props.popUpMenu.close, this.props.popUpMenu.opacity)
        }
        
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref } onClick={this.handleDelete}>
                    <AssignButton popUpMenu={true}></AssignButton>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
        userRole  : state.userRole,
        selectedCardsGroups : state.selectedCardsGroups,
        cardsGroupsData : state.projectData.cards_groups
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        popUpMessageChange : popUpMessageChange,
        deletedCardsGroupsChange : deletedCardsGroupsChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(AsignUsersButton)